import React from 'react';

import { LinkWrapper } from 'app/common/components/singlespa/link-wrapper';

import classNames from 'classnames';

import styles from './ExpandableNavigation.less';

export const ExpandableNavigation: React.FunctionComponent = (props) => (
  <div {...props} className={classNames(styles.expandableNavItemSection)} />
);

export const ExpandableNavigationItemList: React.FunctionComponent = (
  props,
) => <ul {...props} className={styles.expandableNavItemList} />;

export const ExpandableNavigationItem: React.FunctionComponent<{
  expanded?: boolean;
}> = ({ expanded, ...props }) => (
  <li
    {...props}
    className={classNames(
      styles.expandableNavItem,
      expanded && styles.expanded,
    )}
  />
);

export const ExpandableNavigationItemRightChild: React.FunctionComponent = (
  props,
) => <div {...props} className={styles.expandableNavItemRightChild} />;

export interface ExpandableNavigationItemIconProps {
  className?: string;
  iconName: string;
}

export const ExpandableNavigationItemIcon: React.FunctionComponent<ExpandableNavigationItemIconProps> = ({
  iconName,
  className,
  ...props
}) => (
  <span
    {...props}
    className={classNames(styles.expandableNavItemIcon, className)}
  >
    <span
      className={classNames(
        `icon-${iconName}`,
        'icon-sm',
        styles.expandableNavItemIconSpan,
      )}
    />
  </span>
);

export interface ExpandableNavigationItemLogoProps {
  logoUrl1x: string;
  logoUrl2x: string;
}

export const ExpandableNavigationItemLogo: React.FunctionComponent<ExpandableNavigationItemLogoProps> = ({
  logoUrl1x,
  logoUrl2x,
  ...props
}) => (
  <img
    src={logoUrl1x}
    srcSet={`${logoUrl1x} 1x, ${logoUrl2x} 2x`}
    width={16}
    height={16}
    alt=""
    role="presentation"
    className={styles.expandableNavItemLogo}
    {...props}
  />
);

export const ExpandableNavigationItemText: React.FunctionComponent = (
  props,
) => <span {...props} className={styles.expandableNavItemText} />;

interface ExpandableNavigationItemBaseProps {
  className?: string;
  indented?: boolean;
  selected?: boolean;
  small?: boolean;
  quiet?: boolean;
}

export type ExpandableNavigationItemLinkProps = ExpandableNavigationItemBaseProps &
  React.DOMAttributes<HTMLAnchorElement>;
export type ExpandableNavigationItemButtonProps = ExpandableNavigationItemBaseProps &
  React.DOMAttributes<HTMLButtonElement>;

export const ExpandableNavigationItemLink: React.FunctionComponent<ExpandableNavigationItemLinkProps> = ({
  className,
  indented,
  selected,
  small,
  quiet,
  ...props
}) => (
  <LinkWrapper
    {...props}
    className={classNames(
      styles.expandableNavItemLink,
      {
        [styles.selected]: selected,
        [styles.small]: small,
        [styles.expandableNavItemListIndent]: indented,
        [styles.quiet]: quiet,
      },
      className,
    )}
  />
);

export const ExpandableNavigationItemButton: React.FunctionComponent<ExpandableNavigationItemButtonProps> = ({
  className,
  indented,
  selected,
  small,
  quiet,
  ...props
}) => (
  <button
    {...props}
    className={classNames(
      styles.expandableNavItemButton,
      {
        [styles.selected]: selected,
        [styles.small]: small,
        [styles.expandableNavItemListIndent]: indented,
        [styles.quiet]: quiet,
      },
      className,
    )}
  />
);
